import { IconChevronLeft } from '@tvg/fuse-icons';
import PropTypes from 'prop-types';
import React from 'react';
import { PlainIconButton } from '../../fuse-buttons/src/buttons';
import { StyledButtonContainer, StyledPreviousButton } from './styled-buttons';

const defaultProps = {
	showButton: false,
};

const propTypes = {
	showButton: PropTypes.bool,
};

function PreviousButton({ showButton, ...props }) {
	return (
		<StyledPreviousButton className={!showButton && 'hidden'}>
			<StyledButtonContainer
				className="fuse-tabs__previous-button-icon-container"
				data-testid="fuse-tabs-previous-button-icon-container-test-id"
			>
				<PlainIconButton
					className="fuse-tabs__previous-button-icon"
					data-testid="fuse-tabs-previous-button-icon-test-id"
					icon={<IconChevronLeft />}
					size="medium"
					srLabel="Show previous tabs"
					{...props}
				/>
			</StyledButtonContainer>

			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="6.1rem"
				height="100%"
				viewBox="0 0 61 44"
				fill="none"
			>
				<rect fill="url(#paint0_linear_previous)" y="0" height="100%" x="0" width="100%" />
				<defs>
					<linearGradient
						id="paint0_linear_previous"
						gradientUnits="userSpaceOnUse"
						x1="0%"
						x2="100%"
						y1="0"
						y2="0"
					>
						<stop offset="0.325" stopColor="var(--color-global-grey200)" stopOpacity="1" />
						<stop offset="1" stopColor="var(--color-global-grey100)" stopOpacity="0" />
					</linearGradient>
				</defs>
				<line
					x1="0%"
					y1="10"
					x2="0%"
					y2="34"
					stroke="var(--color-global-grey400)"
					strokeWidth="1px"
				/>
			</svg>
		</StyledPreviousButton>
	);
}

PreviousButton.propTypes = propTypes;
PreviousButton.defaultProps = defaultProps;

export default PreviousButton;
